<template>
  <div class="ai-background">
    <!-- <img src="/landing/log-sof-icon.png" alt="AI Logo" class="ai-logo" /> -->
    <!-- <canvas ref="canvas" class="ai-canvas"></canvas> -->
    <div id="neural-network" ref="neuralNetwork"></div>
  </div>
</template>

<script>
export default {
  name: "AnimatedAiBackground",

  data() {
    return {
      particles: [],
      nodes: [],
      streams: [],
      binaryElements: [],
      knowledgeSymbols: [
        "∞",
        "∫",
        "∑",
        "∅",
        "∆",
        "π",
        "Ω",
        "Ψ",
        "λ",
        "Φ",
        "√",
        "≈",
        "≡",
        "⊕",
      ],
      codeFragments: [
        "¡Hola! Acabo de completar mi reserva y estoy muy satisfecho con lo fácil que fue el proceso.",
        "¡Fantástico! no demoré en concretar la reserva para el 8 de septiembre a las 3:00 PM.",
        "Muchas gracias por la atención rápida y amable.",
        "¡Nos vemos en su cita!",
      ],
      connectionPulseInterval: null,
      animationFrameId: null,
      connectionsPerSecond: 0,
      cpuUsage: 15,
      animationRunning: true,
      connectionCounter: 0,
      lastConnectionCount: 0,
      lastUpdateTime: Date.now(),
    };
  },
  mounted() {
    // this.initCanvas();
    this.$nextTick(() => {
      this.initBackground();
    });

    window.addEventListener("resize", this.handleResize);

    // Iniciar monitorización de rendimiento
    this.performanceMonitor();
  },
  methods: {
    initCanvas() {
      const canvas = this.$refs.canvas;
      const ctx = canvas.getContext("2d");

      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;

      const particles = [];
      const num = 75;

      for (let i = 0; i < num; i++) {
        particles.push({
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height,
          radius: Math.random() * 1.5 + 1,
          dx: (Math.random() - 0.5) * 0.5,
          dy: (Math.random() - 0.5) * 0.5,
        });
      }

      const draw = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        for (let i = 0; i < num; i++) {
          const p = particles[i];
          p.x += p.dx;
          p.y += p.dy;

          if (p.x < 0 || p.x > canvas.width) p.dx *= -1;
          if (p.y < 0 || p.y > canvas.height) p.dy *= -1;

          ctx.beginPath();
          ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
          ctx.fillStyle = "rgba(0, 200, 255, 0.7)";
          ctx.fill();

          for (let j = i + 1; j < num; j++) {
            const q = particles[j];
            const dist = Math.hypot(p.x - q.x, p.y - q.y);
            if (dist < 100) {
              ctx.beginPath();
              ctx.moveTo(p.x, p.y);
              ctx.lineTo(q.x, q.y);
              ctx.strokeStyle = "rgba(0, 200, 255, 0.1)";
              ctx.stroke();
            }
          }
        }
        requestAnimationFrame(draw);
      };
      draw();
    },

    initBackground() {
      //   this.createNodes();
      //   this.createParticles();
      //   this.createDataStreams();
      this.createBinaryRain();
      // this.createKnowledgeSymbols();
      //   this.createQuantumLinks();
      this.createCodeParticles();
      //   this.createConnectionPulses();
      this.animate();
    },
    createNodes() {
      const container = this.$refs.neuralNetwork;
      const nodeCount = 25;
      const width = window.innerWidth;
      const height = window.innerHeight;

      for (let i = 0; i < nodeCount; i++) {
        const node = document.createElement("div");
        node.className = "ai-particle";

        const size = Math.random() * 15 + 8;
        node.style.width = `${size}px`;
        node.style.height = `${size}px`;
        node.style.opacity = `0.5`;
        // node.style.backgroundImage = url("/landing/log-sof-icon.png");

        const hue = 170 + Math.random() * 50;
        node.style.background = `hsla(${hue}, 100%, 70%, 0.8)`;
        node.style.boxShadow = `0 0 20px hsla(${hue}, 100%, 70%, 0.6)`;

        const posX = Math.random() * width;
        const posY = Math.random() * height;
        node.style.left = `${posX}px`;
        node.style.top = `${posY}px`;

        this.nodes.push({
          element: node,
          x: posX,
          y: posY,
          vx: (Math.random() - 0.5) * 0.8,
          vy: (Math.random() - 0.5) * 0.8,
          size: size,
          hue: hue,
        });

        container.appendChild(node);
      }
    },
    createParticles() {
      const container = this.$refs.neuralNetwork;
      const particleCount = 120;

      for (let i = 0; i < particleCount; i++) {
        const particle = document.createElement("div");
        particle.className = "ai-particle";

        const size = Math.random() * 5 + 1;
        particle.style.width = `${size}px`;
        particle.style.height = `${size}px`;

        const hue = 160 + Math.random() * 60;
        particle.style.background = `hsla(${hue}, 100%, 70%, ${
          Math.random() * 0.4 + 0.2
        })`;
        particle.style.boxShadow = `0 0 ${
          Math.random() * 8 + 4
        }px hsla(${hue}, 100%, 70%, 0.3)`;

        particle.style.left = `${Math.random() * 100}vw`;
        particle.style.top = `${Math.random() * 100}vh`;

        this.particles.push({
          element: particle,
          x: parseFloat(particle.style.left),
          y: parseFloat(particle.style.top),
          vx: (Math.random() - 0.5) * 2,
          vy: (Math.random() - 0.5) * 2,
          size: size,
          hue: hue,
        });

        container.appendChild(particle);
      }
    },
    createDataStreams() {
      const container = this.$refs.neuralNetwork;
      const streamCount = 15;

      for (let i = 0; i < streamCount; i++) {
        const stream = document.createElement("div");
        stream.className = "data-stream";

        const length = Math.random() * 400 + 150;
        stream.style.width = `${length}px`;

        const thickness = Math.random() * 3 + 1;
        stream.style.height = `${thickness}px`;

        const hue = 160 + Math.random() * 60;
        stream.style.background = `linear-gradient(90deg, transparent, hsla(${hue}, 100%, 70%, 0.7), transparent)`;

        const posX = Math.random() * window.innerWidth;
        const posY = Math.random() * window.innerHeight;
        const angle = Math.random() * 360;

        stream.style.left = `${posX}px`;
        stream.style.top = `${posY}px`;
        stream.style.transform = `rotate(${angle}deg)`;

        this.streams.push({
          element: stream,
          x: posX,
          y: posY,
          angle: angle,
          length: length,
          thickness: thickness,
          speed: Math.random() * 0.7 + 0.1,
          hue: hue,
        });

        container.appendChild(stream);
      }
    },
    createBinaryRain() {
      const container = this.$refs.neuralNetwork;
      const rainCount = 150;

      for (let i = 0; i < rainCount; i++) {
        const binary = document.createElement("div");
        binary.className = "binary-rain";
        binary.textContent = Math.random() > 0.5 ? "0" : "1";

        binary.style.fontSize = `${Math.random() * 12 + 10}px`;
        binary.style.opacity = Math.random() * 0.3 + 0.05;
        binary.style.left = `${Math.random() * 100}vw`;
        binary.style.top = `${Math.random() * 100}vh`;

        this.binaryElements.push({
          element: binary,
          y: parseFloat(binary.style.top),
          speed: Math.random() * 3 + 1,
        });

        container.appendChild(binary);
      }
    },
    createKnowledgeSymbols() {
      const container = this.$refs.neuralNetwork;
      const symbolCount = 30;

      for (let i = 0; i < symbolCount; i++) {
        const symbol = document.createElement("div");
        symbol.className = "knowledge-symbol";
        symbol.textContent =
          this.knowledgeSymbols[
            Math.floor(Math.random() * this.knowledgeSymbols.length)
          ];

        symbol.style.fontSize = `${Math.random() * 20 + 18}px`;
        symbol.style.opacity = Math.random() * 0.3 + 0.1;
        symbol.style.left = `${Math.random() * 100}vw`;
        symbol.style.top = `${Math.random() * 100}vh`;

        symbol.animate(
          [
            { transform: "rotate(0deg) scale(1)" },
            {
              transform: `rotate(${Math.random() > 0.5 ? "-" : ""}${
                Math.random() * 30 + 10
              }deg) scale(${Math.random() * 0.5 + 0.8})`,
            },
            { transform: "rotate(0deg) scale(1)" },
          ],
          {
            duration: Math.random() * 10000 + 5000,
            iterations: Infinity,
            easing: "ease-in-out",
          }
        );

        container.appendChild(symbol);
      }
    },
    createQuantumLinks() {
      const container = this.$refs.neuralNetwork;
      const linkCount = 12;

      for (let i = 0; i < linkCount; i++) {
        const link = document.createElement("div");
        link.className = "quantum-link";

        const length = Math.random() * 300 + 100;
        link.style.width = `${length}px`;

        const thickness = Math.random() * 2 + 0.5;
        link.style.height = `${thickness}px`;

        const posX = Math.random() * window.innerWidth;
        const posY = Math.random() * window.innerHeight;
        const angle = Math.random() * 360;

        link.style.left = `${posX}px`;
        link.style.top = `${posY}px`;
        link.style.transform = `rotate(${angle}deg)`;

        this.streams.push({
          element: link,
          x: posX,
          y: posY,
          angle: angle,
          length: length,
          thickness: thickness,
          speed: Math.random() * 0.5 + 0.05,
          isQuantum: true,
        });

        container.appendChild(link);
      }
    },
    createCodeParticles() {
      const container = this.$refs.neuralNetwork;
      const codeCount = 25;

      for (let i = 0; i < codeCount; i++) {
        const code = document.createElement("div");
        code.className = "code-particle";
        code.textContent =
          this.codeFragments[
            Math.floor(Math.random() * this.codeFragments.length)
          ];

        code.style.fontSize = `${Math.random() * 4 + 10}px`;
        code.style.opacity = Math.random() * 0.4 + 0.1;
        code.style.left = `${Math.random() * 100}vw`;
        code.style.top = `${Math.random() * 100}vh`;

        const duration = Math.random() * 30000 + 15000;
        code.animate(
          [
            { transform: "translate(0, 0) rotate(0deg)" },
            {
              transform: `translate(${Math.random() * 200 - 100}px, ${
                Math.random() * 100 - 50
              }px) rotate(${Math.random() * 20 - 10}deg)`,
            },
          ],
          {
            duration: duration,
            iterations: Infinity,
            direction: "alternate",
            easing: "ease-in-out",
          }
        );

        container.appendChild(code);
      }
    },
    createConnectionPulses() {
      this.connectionPulseInterval = setInterval(() => {
        if (this.nodes.length > 1) {
          const node1 =
            this.nodes[Math.floor(Math.random() * this.nodes.length)];
          const node2 =
            this.nodes[Math.floor(Math.random() * this.nodes.length)];

          if (node1 !== node2) {
            this.createPulseConnection(node1, node2);
            this.connectionCounter++;
          }
        }

        if (this.nodes.length > 0) {
          const coreX = window.innerWidth / 2;
          const coreY = window.innerHeight / 2;
          const node =
            this.nodes[Math.floor(Math.random() * this.nodes.length)];
          this.createPulseConnection({ x: coreX, y: coreY, hue: 180 }, node);
          this.connectionCounter++;
        }
      }, 200);
    },
    createPulseConnection(point1, point2) {
      const container = this.$refs.neuralNetwork;
      const line = document.createElement("div");
      line.className = "pulse-circle";

      const centerX = (point1.x + point2.x) / 2;
      const centerY = (point1.y + point2.y) / 2;

      const dx = point2.x - point1.x;
      const dy = point2.y - point1.y;
      const distance = Math.sqrt(dx * dx + dy * dy);

      const angle = (Math.atan2(dy, dx) * 180) / Math.PI;

      line.style.width = "5px";
      line.style.height = "5px";
      line.style.left = `${centerX}px`;
      line.style.top = `${centerY}px`;

      const hue = point1.hue || point2.hue || 180;
      line.style.borderColor = `hsla(${hue}, 100%, 70%, 0.4)`;

      container.appendChild(line);

      const animation = line.animate(
        [
          {
            width: "5px",
            height: "5px",
            opacity: 0.7,
            transform: `translate(-50%, -50%) rotate(${angle}deg)`,
          },
          {
            width: `${distance}px`,
            height: `${distance}px`,
            opacity: 0,
            transform: `translate(-50%, -50%) rotate(${angle}deg)`,
          },
        ],
        {
          duration: 2000,
          easing: "ease-out",
        }
      );

      animation.onfinish = () => {
        if (line.parentElement === container) {
          container.removeChild(line);
        }
      };
    },
    animate() {
      if (!this.animationRunning) {
        return;
      }

      const width = window.innerWidth;
      const height = window.innerHeight;

      // Animar nodos
      this.nodes.forEach((node) => {
        node.x += node.vx;
        node.y += node.vy;

        if (node.x < 0 || node.x > width) node.vx *= -1;
        if (node.y < 0 || node.y > height) node.vy *= -1;

        node.element.style.left = `${node.x}px`;
        node.element.style.top = `${node.y}px`;
      });

      // Animar partículas
      this.particles.forEach((p) => {
        p.x += p.vx;
        p.y += p.vy;

        if (p.x < 0 || p.x > width) p.vx *= -1;
        if (p.y < 0 || p.y > height) p.vy *= -1;

        p.element.style.left = `${p.x}px`;
        p.element.style.top = `${p.y}px`;
      });

      // Animar flujos de datos
      this.streams.forEach((stream) => {
        stream.angle += stream.speed;
        stream.element.style.transform = `rotate(${stream.angle}deg)`;

        if (stream.isQuantum && Math.random() > 0.7) {
          stream.element.style.opacity = Math.random() * 0.5 + 0.1;
        }
      });

      // Animar lluvia binaria
      this.binaryElements.forEach((binary) => {
        binary.y += binary.speed;

        if (binary.y > height) {
          binary.y = -20;
          binary.element.style.left = `${Math.random() * 100}vw`;
        }

        binary.element.style.top = `${binary.y}px`;
      });

      this.animationFrameId = requestAnimationFrame(this.animate);
    },
    handleResize() {
      this.nodes.forEach((node) => {
        if (node.x > window.innerWidth) node.x = window.innerWidth;
        if (node.y > window.innerHeight) node.y = window.innerHeight;
      });
    },
    performanceMonitor() {
      setInterval(() => {
        const now = Date.now();
        const elapsed = (now - this.lastUpdateTime) / 1000;

        if (elapsed >= 1) {
          this.connectionsPerSecond = Math.round(
            this.connectionCounter / elapsed
          );
          this.connectionCounter = 0;
          this.lastUpdateTime = now;

          // Simular fluctuaciones de CPU
          this.cpuUsage = 15 + Math.floor(Math.random() * 10);
        }
      }, 500);
    },
    toggleAnimation() {
      this.animationRunning = !this.animationRunning;
      if (this.animationRunning) {
        this.animate();
      } else {
        cancelAnimationFrame(this.animationFrameId);
      }
    },
    resetAnimation() {
      // Limpiar todo
      this.cleanup();

      // Resetear estadísticas
      this.connectionsPerSecond = 0;
      this.connectionCounter = 0;
      this.cpuUsage = 15;

      // Reiniciar animación
      this.initBackground();
    },
    cleanup() {
      // Limpiar elementos del DOM
      const container = this.$refs.neuralNetwork;
      while (container.firstChild) {
        container.removeChild(container.firstChild);
      }

      // Limpiar arrays
      this.particles = [];
      this.nodes = [];
      this.streams = [];
      this.binaryElements = [];

      // Detener intervalos y animaciones
      if (this.connectionPulseInterval) {
        clearInterval(this.connectionPulseInterval);
        this.connectionPulseInterval = null;
      }

      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = null;
      }
    },
  },
};
</script>

<style scoped>
.ai-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  /* background: radial-gradient(circle at center, #001020, #000); */
  background: radial-gradient(circle at center, #0a0e2a, #000115);
  overflow: hidden;
  z-index: -1;
}

.ai-logo {
  position: absolute;
  top: 50%;
  left: 5%;
  transform: translate(-50%, -50%);
  width: 100px;
  animation: pulse 6s infinite ease-in-out;
  filter: drop-shadow(0 0 10px #00c8ff);
}

@keyframes pulse {
  0%,
  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.05);
    opacity: 0.8;
  }
}

.ai-canvas {
  position: absolute;
  width: 100%;
  height: 100%;
}

/* Animaciones DeepSeek */

/* body {
  background: radial-gradient(circle at center, #0a0e2a, #000115);
  color: #e0f7fa;
  font-family: "Segoe UI", "Roboto", sans-serif;
  min-height: 100vh;
  overflow: hidden;
  position: relative;
} */
</style>

<style>
/* body {
  background: radial-gradient(circle at center, #0a0e2a, #000115);
} */

@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-15px);
  }
}

/* Nuevos elementos de representación */
.knowledge-symbol {
  position: absolute;
  font-size: 28px;
  color: rgba(0, 255, 255, 0.25);
  z-index: 5;
  filter: drop-shadow(0 0 5px rgba(0, 200, 255, 0.5));
}

.quantum-link {
  position: absolute;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    #ff00ff,
    #00ffcc,
    transparent
  );
  opacity: 0.3;
  z-index: 4;
}

.code-particle {
  position: absolute;
  font-family: "Courier New", monospace;
  font-size: 14px;
  color: rgba(0, 255, 200, 0.4);
  z-index: 3;
  text-shadow: 0 0 3px rgba(0, 255, 200, 0.5);
}

/* .ai-core {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 180px;
        height: 180px;
        border-radius: 50%;
        background: radial-gradient(circle, #00ffcc, #00e5ff, #d400ff);
        box-shadow: 0 0 80px rgba(0, 230, 255, 0.8),
          0 0 150px rgba(212, 0, 255, 0.4);
        transform: translate(-50%, -50%);
        z-index: 10;
        animation: pulse 4s infinite ease-in-out;
      }

      .core-ring {
        position: absolute;
        top: 50%;
        left: 50%;
        border-radius: 50%;
        border: 2px solid transparent;
        transform: translate(-50%, -50%);
        z-index: 9;
      }

      .ring-1 {
        width: 240px;
        height: 240px;
        border-color: rgba(0, 230, 255, 0.2);
        animation: rotate 30s infinite linear reverse;
      }

      .ring-2 {
        width: 320px;
        height: 320px;
        border-color: rgba(212, 0, 255, 0.15);
        animation: rotate 45s infinite linear;
      }

      .ring-3 {
        width: 400px;
        height: 400px;
        border-color: rgba(0, 255, 200, 0.1);
        animation: rotate 60s infinite linear reverse;
      } */

@keyframes rotate {
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

/* Elementos de fondo existentes (mejorados) */
#neural-network {
  position: fixed;
  top: 0;
  left: 0;
  /* width: 100%;
  height: 100%; */
  z-index: 1;
}

.ai-particle {
  position: absolute;
  background: rgba(0, 230, 255, 0.7);
  border-radius: 50%;
  box-shadow: 0 0 15px rgba(0, 230, 255, 0.5);
  /* background-image: url("/landing/log-sof-icon.png"); */
  z-index: 2;
}

.data-stream {
  position: absolute;
  height: 2px;
  background: linear-gradient(90deg, transparent, #00ffcc, transparent);
  opacity: 0.4;
  z-index: 1;
}

.binary-rain {
  position: absolute;
  color: rgba(0, 255, 200, 0.15);
  font-size: 18px;
  font-family: "Courier New", monospace;
  z-index: 2;
}

.pulse-circle {
  position: absolute;
  border-radius: 50%;
  border: 1px solid rgba(0, 230, 255, 0.3);
  transform: translate(-50%, -50%);
  z-index: 0;
}

@keyframes pulse {
  0%,
  100% {
    transform: translate(-50%, -50%) scale(1);
    box-shadow: 0 0 80px rgba(0, 230, 255, 0.8),
      0 0 150px rgba(212, 0, 255, 0.4);
  }
  50% {
    transform: translate(-50%, -50%) scale(1.15);
    box-shadow: 0 0 100px rgba(0, 230, 255, 0.9),
      0 0 180px rgba(212, 0, 255, 0.6);
  }
}
</style>
